import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../services/api';

function ProgressTracker({ userId }) {
  const { t, i18n } = useTranslation();
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadProgress = useCallback(async () => {
    try {
      const data = await api.getProgress(userId, i18n.language);
      setProgress(data);
    } catch (error) {
      console.error('Error loading progress:', error);
    } finally {
      setLoading(false);
    }
  }, [userId, i18n.language]);

  useEffect(() => {
    loadProgress();
    // Refresh progress every 10 seconds
    const interval = setInterval(loadProgress, 10000);
    return () => clearInterval(interval);
  }, [loadProgress]);

  if (loading || !progress) {
    return <div className="progress-tracker">Loading...</div>;
  }

  return (
    <div className="progress-tracker">
      <h2>{t('progress.title')}</h2>
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${progress.percentage}%` }}
        >
          {progress.percentage}%
        </div>
      </div>
      <div className="progress-text">
        {progress.completed} / {progress.total} {t('checklist.completed')}
      </div>
      <div style={{ marginTop: '15px', fontSize: '0.9rem', color: '#666' }}>
        {t('progress.week')}
      </div>
    </div>
  );
}

export default ProgressTracker;

